import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { useLazyQuery } from '@apollo/client';
import Layout from 'components/Layout/Layout';
import { DataRangeFilter } from 'components/DataRangeFilter/DataRangeFilter';
import { SITE_BY_DOMAIN } from 'queries/site';
import { UserService } from 'services/User/UserService';
import PageError from '../../../components/PageError';
import PageTitle from '../../../components/PageTitle/PageTitle';

import useStyles from '../components/styles';
import { UpdateSiteSettings } from '../components/edit';

const SiteSettings: React.FC = () => {
  const classes = useStyles();

  const sites = UserService.useSitesFromAccess();
  const [sitesFilter, setSitesFilter] = useState<string[]>([]);

  const [loadSiteLanguages, { data: siteData, loading: siteLoading, error }] = useLazyQuery(SITE_BY_DOMAIN);

  const siteLanguages = siteData?.siteByDomain;

  useEffect(() => {
    if (sitesFilter.length) {
      const domain = sitesFilter[0];
      loadSiteLanguages({ variables: { domain } });
    }
  }, [sitesFilter, loadSiteLanguages]);

  const permissions = {
    showSitesFilter: true,
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={2}>
          <PageTitle title="Site Settings" />
        </Grid>
        <Grid xs={5} item />
        <Grid item xs={5}>
          <DataRangeFilter
            filterSite={sitesFilter}
            setFilterSite={setSitesFilter}
            sites={sites}
            permissions={permissions}
            customColumnSize={12}
          />
        </Grid>
      </Grid>
      {siteLoading || !siteLanguages ? (
        <Paper className={classes.paper}>Please, select a site.</Paper>
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <UpdateSiteSettings data={siteLanguages} refetch={() => loadSiteLanguages({ variables: { domain: sitesFilter[0] } })} />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Layout>
  );
};

export default SiteSettings;
